import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AppStateService } from '../app-state.service';
import { StudijnyProgram } from '../model/studijny-program';
import { TypZaznamuTextu } from '../model/typ-zaznamu-textu';
import { ZaznamTextu } from '../model/zaznam-textu';
import { StudijneProgramyComponent } from '../studijne-programy/studijne-programy.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-studijne-programy-zaznamu',
    templateUrl: './studijne-programy-zaznamu.component.html',
    styleUrls: ['./studijne-programy-zaznamu.component.css'],
    standalone: false
})
export class StudijneProgramyZaznamuComponent implements OnInit {

  @Input() typZaznamuTextu: TypZaznamuTextu;
  @Input() kodJazyk: string;
  // TODO: premenovat na indexPolozkyVoFormulari
  @Input() poradiePolozkyVoFormulari: number;
  @Input() mapaJazykovAFormArrays: Map<string, UntypedFormArray>;
  @Input() somPoslednaOpakovanaPolozka: boolean;

  mapaPoradiAStudProgramovZaznamu: Map<number, StudijnyProgram[]>;

  readonly INPUT: number = 1;
  readonly TEXTAREA: number = 2;

  constructor(public dialog: MatDialog,
    public appStateService: AppStateService,
    private http: HttpClient,
    private translateService: TranslateService) { }

  ngOnInit(): void {
    if (this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
      .get(this.typZaznamuTextu.id)) {

        this.mapaPoradiAStudProgramovZaznamu =
          this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
            .get(this.typZaznamuTextu.id).get(this.kodJazyk);
      }

  }

  openStudijneProgramyDialog(poradieZobrazeniaVoFormulari: number) {
    this.http.get<StudijnyProgram[]>('/ais/rest/apps/vsk/pripustne-stud-programy-podprogramu/'
        + this.appStateService.idPodprogram + '/' + this.appStateService.akRok?.replace('/','-'))
      .subscribe({
        next: (studProgramyPodprogramu: StudijnyProgram[]) => {

          if (this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
            .get(this.typZaznamuTextu.id)) {

                this.mapaPoradiAStudProgramovZaznamu = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
                  .get(this.typZaznamuTextu.id).get(this.kodJazyk);
          }

          let poradie = poradieZobrazeniaVoFormulari;
          const mapaIdTypovAMapJazykovAPoliPoradi
            = this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1.get(this.typZaznamuTextu.id);

          if (mapaIdTypovAMapJazykovAPoliPoradi && mapaIdTypovAMapJazykovAPoliPoradi.get(this.kodJazyk)) {
              const polePoradi = mapaIdTypovAMapJazykovAPoliPoradi.get(this.kodJazyk);
              // vyberieme a odstranime prvy prvok z pola
              // poradie = polePoradi.shift();
              if (polePoradi[poradieZobrazeniaVoFormulari - 1]) {
                poradie = polePoradi[poradieZobrazeniaVoFormulari - 1];
              }
           }


          let zaznamTextu = null;
          if (!this.mapaPoradiAStudProgramovZaznamu || !this.mapaPoradiAStudProgramovZaznamu.get(poradie)) {
            zaznamTextu = this.getZaznamPodlaPoradia(poradie);
          } else {
            // tato metoda prejde cely zoznam stud. programov podprogramu a oznaci tie spravne pre dany zaznam
            this.oznacStudProgramyZaznamu(poradie, studProgramyPodprogramu);
          }
          // ak editujeme novu polozku, este neexistuje zaznamTextu, a teda neoznacujeme ziadny stud. pre podprogram
          // if (zaznamTextu) {
            // this.studProgramyPodprogramu = studProgramy;
            // studProgramy = this.oznacAVratStudProgramyZaznamu(poradie, studProgramy);
          // }

          const dialogRef = this.dialog.open(
            StudijneProgramyComponent, {
              data: {
                studProgramy: studProgramyPodprogramu
              }
            });

            dialogRef.afterClosed().subscribe(result => {
              // console.log('The dialog was closed');
              // console.log('Stud.programy: ' + JSON.stringify(studProgramyPodprogramu));
              // console.log('Result: ' + JSON.stringify(result));
              if (!result) {
                return;
              }

              const studProgramyZaznamu = this.vratOznaceneStudProgramy(studProgramyPodprogramu);
              // console.log('Stud. programu zaznamu: ' + JSON.stringify(studProgramyZaznamu));
              if (studProgramyZaznamu && !this.mapaPoradiAStudProgramovZaznamu) {
                this.mapaPoradiAStudProgramovZaznamu = new Map();
              }
              this.mapaPoradiAStudProgramovZaznamu.set(poradie, studProgramyZaznamu);

              const mapaJazykovAMapPoradiAStudProgramov: Map<string, Map<number, StudijnyProgram[]>>
                = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov.get(this.typZaznamuTextu.id);

              if (!mapaJazykovAMapPoradiAStudProgramov) {
                const mapaJazykovAMapPoradiAStudProgramov: Map<string, Map<number, StudijnyProgram[]>> = new Map();
                mapaJazykovAMapPoradiAStudProgramov.set(this.kodJazyk, this.mapaPoradiAStudProgramovZaznamu);
                this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov.set(this.typZaznamuTextu.id,
                  mapaJazykovAMapPoradiAStudProgramov);
              } else if (!mapaJazykovAMapPoradiAStudProgramov.get(this.kodJazyk)) {
                const mapa
                  = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov.get(this.typZaznamuTextu.id);
                mapa.set(this.kodJazyk, this.mapaPoradiAStudProgramovZaznamu);
              }

            });

        },
        error: (error) => {
          console.error(error);
        }
    });
  }

  oznacStudProgramyZaznamu(poradie: number, studProgramyPodprogramu: StudijnyProgram[]) {
    const studProgramyZaznamu = this.mapaPoradiAStudProgramovZaznamu.get(poradie);
    if (studProgramyZaznamu) {
      let idckaProgramovZaznamu = studProgramyZaznamu.map(sp => sp.id);
      if (studProgramyPodprogramu) {
        for (const studProgramPP of studProgramyPodprogramu) {
          if (idckaProgramovZaznamu && idckaProgramovZaznamu.includes(studProgramPP.id)) {
            studProgramPP.zaradeny = true;
          }
        }
      }
    }
  }

  getZaznamPodlaPoradia(poradie: number): ZaznamTextu {

    let zaznamyTextovPreTyp = [];
    for (const zaznam of this.appStateService.zaznamyTextovZDB) {
      if (zaznam.idTypZaznamTextu === this.typZaznamuTextu.id) {
        zaznamyTextovPreTyp.push(zaznam);
      }
    }

    let zaznam: ZaznamTextu = null;
    for (const z of zaznamyTextovPreTyp) {
      if (z.poradie === poradie) {
        zaznam = z;
        break;
      }
    }

    return zaznam;
  }

  vratOznaceneStudProgramy(studProgramy: StudijnyProgram[]): StudijnyProgram[] {
    let studProgramyOznacene: StudijnyProgram[] = [];

    for (const sp of studProgramy) {
      if (sp.zaradeny) {
        studProgramyOznacene.push(sp);
      }
    }

    return studProgramyOznacene;
  }


  getStudProgramyZaznamu(poradieZobrazeniaVoFormulari: number) {
    if (!this.mapaPoradiAStudProgramovZaznamu
        && this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
            .get(this.typZaznamuTextu.id)) {

      this.mapaPoradiAStudProgramovZaznamu = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
        .get(this.typZaznamuTextu.id).get(this.kodJazyk);
    }

    let poradie = poradieZobrazeniaVoFormulari;
    const mapaIdTypovAMapJazykovAPoliPoradi
      = this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1.get(this.typZaznamuTextu.id);
    if (mapaIdTypovAMapJazykovAPoliPoradi && mapaIdTypovAMapJazykovAPoliPoradi.get(this.kodJazyk)) {
      const polePoradi = mapaIdTypovAMapJazykovAPoliPoradi.get(this.kodJazyk);
      // vyberieme a odstranime prvy prvok z pola
      // poradie = polePoradi.shift();
      if (polePoradi[poradieZobrazeniaVoFormulari - 1]) {
        poradie = polePoradi[poradieZobrazeniaVoFormulari - 1];
      }
}

    if (!this.mapaPoradiAStudProgramovZaznamu || !this.mapaPoradiAStudProgramovZaznamu.get(poradie)) {
      return '';
    }

    let result = '';
    const studProgramy = this.mapaPoradiAStudProgramovZaznamu.get(poradie);
    studProgramy.sort((sp1,sp2) => sp1.skratka.localeCompare( sp2.skratka));
    for (let index = 0; index < studProgramy.length; index++) {
      const sp = studProgramy[index];
      if (index > 0) {
        result += ', ';
      }
      result += sp.skratka + ' - ' + sp.popis;
    }

    return result;
  }

  getOpenStudProgramyDialogTooltip() {
    return this.translateService.instant('Výber štud. programov');
  }

}
